import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://jyqagaxnzesormhsykez.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imp5cWFnYXhuemVzb3JtaHN5a2V6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTI1Mzc1NDYsImV4cCI6MjA2ODExMzU0Nn0.LmMYuhRzOWKuQMBjk27m2FqntL0Fn6gT7Z6oc_7xm6g'

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing Supabase credentials')
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})